import React, {useState} from "react";
import Form from "../../lib/appfuse-react/component/Form";
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel, MenuItem,
    Select,
    FormHelperText, FormLabel
} from "@material-ui/core";
import i18n from "../../lib/appfuse-react/core/i18n";
import UserEvent from "../../lib/appfuse-react/core/UserEvent";
import Box from "../../lib/appfuse-react/component/Box";
import codeUtils from "../../util/CodeUtils";
import lang from "../../lib/appfuse-react/core/lang";
import SelectField from "../../lib/appfuse-react/component/SelectField";
import {useSelector} from "../../store";
import {selectCounty} from "../../reducer/util/utilReducer";
import TextField from "../../lib/appfuse-react/component/TextField";


function Address(props){
    const { value, disabled, counties=[] } = props;
    const selectCountyData = useSelector(selectCounty);
    const county = lang.isNotEmpty(selectCountyData) ? selectCountyData : counties;
    const { towns=[] } = county.find(item => item.code === value.county) || {};

    const handleChange = ({value: newValue}) => {
        if(lang.isNotUndefined(newValue?.county) && newValue?.county !== value?.county) {
            newValue.town = null;
            newValue.zip = null;
        }
        if(newValue?.town){
            newValue.zip = towns.find(item => item.code === newValue.town)?.zip;
        }else {
            newValue.zip = null;
        }

        props.onChange(new UserEvent({value: newValue}));
    }

    return (
        <Form value={value} onChange={handleChange} fullWidth fullHeight display="flex" flexDirection="column">
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <SelectField name="county" label="County" variant="outlined" fullWidth options={county}
                                 valueAccessor="code" textAccessor="name" disabled={disabled}/>
                </Grid>
                <Grid item xs={2}>
                    <SelectField name="town" label="District" variant="outlined" fullWidth options={towns}
                                 valueAccessor="code" textAccessor="name" disabled={disabled}/>
                </Grid>
                <Grid item xs={2}>
                    <TextField name="zip" label="Zip" variant="outlined" fullWidth disabled={disabled}/>
                </Grid>
                <Grid item xs={6}>
                    <TextField name="street" label="Street" variant="outlined" fullWidth disabled={disabled}/>
                </Grid>
            </Grid>
        </Form>
    )
}

export function AddressTextField(props){
    const { value } = props;
    const options = lang.omit(props, 'name', 'value');
    const counties = useSelector(selectCounty);
    const text = GetAddressText({address: value, counties});

    return <TextField value={text} {...options}/>

}

export function GetAddressText(props){
    const { address={}, counties=[] } = props;
    if (lang.isNotEmpty(address) && lang.isString(address)) return address;
    const { towns=[] } = counties.find(item => item.code === address?.county) || {};
    const county = counties.find(item => item.code === address?.county)?.name || "";
    const town = towns.find(item => item.code === address?.town)?.name || "";

    const zip = lang.isNullOrUndefined(address?.zip)? "" : address?.zip;
    const street = lang.isNullOrUndefined(address?.street)? "" : address?.street;
    return `${zip}${county}${town}${street}`;
}

function OtherAddress(props){
    const {subtitle, value, hint="", sameAddressTitle, required=false} = props;
    const {permanentAddress=[]} = value;
    const [checked, setChecked] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [newAddress, setNewAddress] = useState(new Array(permanentAddress.length));
    const cities = codeUtils.getData('city');

    const handleChecked = event => {
        const checked = event.target.checked;
        const data = checked? {...props.value, [subtitle]: permanentAddress} : {...props.value, [subtitle]: newAddress};
        props.onChange(new UserEvent({value: data}));
        setChecked(checked);
        setDisabled(!disabled);
    }

    const handleChange = event => {
        const {value} = event;
        const data = {...props.value, [subtitle]: value};
        props.onChange(new UserEvent({value: data}));
        setNewAddress(value);
    }

    let data = newAddress;
    if(checked){
        data = permanentAddress;
    }

    return (
        <Form value={data} onChange={handleChange}>
            <Box display="flex" justifyContent="flex-start" alignItems="center" gap={1}>
                <FormLabel required={required}>{i18n.translate(subtitle)}</FormLabel>
                <FormControlLabel
                    control={<Checkbox checked={checked} onChange={handleChecked}/>}
                    label={i18n.translate(sameAddressTitle)}
                />
                {lang.isNotEmpty(hint) && <FormHelperText>{i18n.translate(hint)}</FormHelperText>}
            </Box>
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel>{i18n.translate("City")}</InputLabel>
                        <Select
                            label="City"
                            name="city"
                            disabled={disabled}
                        >
                            {cities.map(city => (
                                <MenuItem value={city.code} key={city.code}>
                                    {city.text}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={2}>
                    <TextField name="district" label="District" variant="outlined" fullWidth disabled={disabled}/>
                </Grid>
                <Grid item xs={2}>
                    <TextField name="zip" label="Zip" variant="outlined" fullWidth disabled={disabled}/>
                </Grid>
                <Grid item xs={6}>
                    <TextField name="street" label="Street" variant="outlined" fullWidth disabled={disabled}/>
                </Grid>

                {/*<Grid item xs={3}>*/}
                {/*    <TextField name={`${subtitle}Phone`} label="Mailing phone" variant="outlined" fullWidth/>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={3}>*/}
                {/*    <TextField name={`${subtitle}Fax`} label="Mailing fax" variant="outlined" fullWidth/>*/}
                {/*</Grid>*/}
            </Grid>
        </Form>
    )
}

const country = [
    {name:'台灣', code:'TW'},
]

export default Address;
export {OtherAddress}